/**
 * Get the backend base URL for static file serving
 * This removes the /api/v1 suffix from the API URL to get the base backend URL
 */
export const getBackendUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001/api/v1';
  return apiUrl.replace('/api/v1', '');
};

/**
 * Get the full URL for a static file
 */
export const getStaticFileUrl = (path: string): string => {
  if (path.startsWith('http') || path.startsWith('data:')) {
    return path;
  }
  return `${getBackendUrl()}${path}`;
};
